import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { STORES } from "utils/api/graphql/queries/stores";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.STORES.LIST.path);
  const [addStore] = useMutation(graphql.mutations.CREATE_STORE, {
    refetchQueries: [
      {
        query: STORES,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.STORES.LIST.path);
    },
  });

  const onSubmit = (data) => {
    return addStore({
      variables: {
        data: {
          id: cuid(),
          ...data,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} id={id} cancel={cancel} />;
};

export default Create;
